import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const ShippingForm = ({ shippingAddress, onChange }) => (
  <Card className="bg-purple-800/50 border-purple-600">
    <CardContent className="pt-6">
      <h2 className="text-2xl font-bold text-white mb-6">Shipping Address</h2>
      <div className="space-y-4">
        <div>
          <Label htmlFor="line1" className="text-purple-200">Address Line 1 *</Label>
          <Input
            id="line1"
            name="line1"
            value={shippingAddress.line1}
            onChange={onChange}
            className="bg-purple-900/50 border-purple-600 text-white"
            required
            data-testid="checkout-line1-input"
          />
        </div>
        <div>
          <Label htmlFor="line2" className="text-purple-200">Address Line 2</Label>
          <Input
            id="line2"
            name="line2"
            value={shippingAddress.line2}
            onChange={onChange}
            className="bg-purple-900/50 border-purple-600 text-white"
            data-testid="checkout-line2-input"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="city" className="text-purple-200">City *</Label>
            <Input
              id="city"
              name="city"
              value={shippingAddress.city}
              onChange={onChange}
              className="bg-purple-900/50 border-purple-600 text-white"
              required
              data-testid="checkout-city-input"
            />
          </div>
          <div>
            <Label htmlFor="state" className="text-purple-200">State *</Label>
            <Input
              id="state"
              name="state"
              value={shippingAddress.state}
              onChange={onChange}
              className="bg-purple-900/50 border-purple-600 text-white"
              placeholder="GA"
              required
              data-testid="checkout-state-input"
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="postal_code" className="text-purple-200">Zip Code *</Label>
            <Input
              id="postal_code"
              name="postal_code"
              value={shippingAddress.postal_code}
              onChange={onChange}
              className="bg-purple-900/50 border-purple-600 text-white"
              required
              data-testid="checkout-zip-input"
            />
          </div>
          <div>
            <Label htmlFor="country" className="text-purple-200">Country</Label>
            <Input
              id="country"
              name="country"
              value={shippingAddress.country}
              onChange={onChange}
              className="bg-purple-900/50 border-purple-600 text-white"
              disabled
            />
          </div>
        </div>
      </div>
    </CardContent>
  </Card>
);
